import { GA } from '../../ga/GA';

export default {
    executor: GA,
    name: 'darwin-evolution',
    getInitialState: () => ({ weight: 0.5 })
};


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/evolution/providers/DarwinEvolution.js